import { render, staticRenderFns } from "./NhLink.vue?vue&type=template&id=a816e8c8"
import script from "./NhLink.vue?vue&type=script&lang=js"
export * from "./NhLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports